import { takeLatest } from 'redux-saga/effects';
import { fetchSubjectsTakenFlow } from './fetchSubjectsTakenflow';
import { schoolsInGroupFlow } from './schoolsInGroupFlow';

/**
 * Export all Context Sagas in one array
 * This is imported into a root saga in the store.
 * Root saga is effectively the same as the root reducer.
 */
export const contextSagas = [
	//trigger for summit home
	takeLatest('groupAnalysis/setGroupTrend', fetchSubjectsTakenFlow),
	//trigger for single school intial load
	takeLatest('context/changePrimaryGradepoint', fetchSubjectsTakenFlow),
	//trigger for single school on primary gradepoint change (avoids infinite rerenders)
	takeLatest('context/triggerSubjectsTaken', fetchSubjectsTakenFlow),

	takeLatest('context/triggerSchoolsInGroup', schoolsInGroupFlow),
	takeLatest('context/retriggerSingleSchoolPerformanceMeasures', schoolsInGroupFlow),
];
